import api from "./Api";

class IbptService {
  GetIbpt(payload) {
    return api.get("/v1/ibpt/" + payload).then((response) => {
      return response.data;
    });
  }

  PostIbpt(payload) {
    return api.post("/v1/ibpt/", payload).then((response) => {
      return response.data;
    });
  }

  PutIbpt(payload) {
    return api.put("/v1/ibpt/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteIbpt(payload) {
    return api.delete("/v1/ibpt/" + payload).then((response) => {
      return response.data;
    });
  }

  GetIbptOData(payload) {
    return api.get("/OData/Ibpt" + payload).then((response) => {
      return response.data;
    });
  }

  GetVersoesAgrupadas() {
    return api.get("/v1/ibpt/VersoesAgrupadas").then((response) => {
      return response.data;
    });
  }

  AtualizarTabelaIbpt(payload) {
    return api
      .post("/v1/ibpt/AtualizarTabelaIbpt", payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new IbptService();
